import { RefObject } from "react";
import { ThreadAutoInteractionConfig } from "@features/Chat/chat-thread-auto-interaction-config";
import { useIntercomStore } from "@store/intercom.store";
import { MessageBarArea } from "../styles";
import { DisclaimerFooter } from "./DisclaimerFooter";
import { MessageBar } from "./MessageBar";
import { ScrollToBottomButton } from "./ScrollToBottomButton";

type Props = {
  containerRef: RefObject<HTMLDivElement>;
  isScrollReady: boolean;
  showScrollToBottom?: boolean;
  scrollToBottomHidden?: boolean;
  stackedLayout?: boolean;
  currentThread?: string;
  onSendMessage: (params: { message: string }) => Promise<{ threadId: string }>;
  onAttachFile: (file: File) => Promise<string>;
  numberOfMessages: number;
  isSendingMessage: boolean;
  isReceivingMessageResponse: boolean;
  isUploadingFile: boolean;
  disabled?: boolean;
  isSubmitDisabled?: boolean;
  threadAutoInteractionConfig?: ThreadAutoInteractionConfig | null;
  hasMoreAutoInteractions: boolean;
  nextMessageIndex: number;
  isOverlayHidden: boolean;
  handleFinishAutoTyping: () => void;
};

export const ChatFooter = ({
  containerRef,
  isScrollReady,
  showScrollToBottom = false,
  scrollToBottomHidden = false,
  stackedLayout,
  ...messageBarProps
}: Props) => {
  const isIntercomOpen = useIntercomStore((state) => state.isIntercomOpen);
  const tooltip = isIntercomOpen
    ? "Sidekick is disabled while the support widget is open"
    : "";
  return (
    <MessageBarArea $stackedLayout={stackedLayout}>
      {showScrollToBottom && (
        <ScrollToBottomButton
          containerRef={containerRef}
          isReady={isScrollReady}
          hidden={scrollToBottomHidden}
        />
      )}
      <MessageBar {...messageBarProps} tooltip={tooltip} />
      <DisclaimerFooter />
    </MessageBarArea>
  );
};
